/* eslint-disable max-lines */
import { downloadGroupKpiReportTemplate, importGroupKpiReportList } from '@mdm/api/targetModdeules/groupKpiReport.js';

export const config = {
    name: 'groupKpiReport',
    searchFields: [
        {
            name: '分组(岗位)',
            value: 'groupNames',
            type: 'advanceMulti',
            advanceConfig: [
                { 'prop': 'groupName', 'value': '分组名称' }
            ],
            tableConfig: [
                { 'prop': 'groupName', 'value': '分组名称', 'displayName': 'groupName' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/goal/manage/groupList',
            cbParams: ['groupName#groupName'],
            isFixed: true,
            span: 6
        },
        {
            name: '目标指标',
            value: 'kpiNames',
            type: 'advanceMulti',
            advanceConfig: [
                { 'prop': 'kpiName', 'value': '指标名称' },
                { 'prop': 'kpiCode', 'value': '指标编码' }
            ],
            tableConfig: [
                { 'prop': 'kpiCode', 'value': '指标编码' },
                { 'prop': 'kpiName', 'value': '指标名称', 'displayName': 'kpiName' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/goal/manage/kpi/page',
            cbParams: ['kpiCode#kpiCode', 'kpiName#kpiName'],
            isFixed: true,
            span: 6
        }
    ],
    selection: true,
    index: false,
    columns: [
        {
            label: 'ID',
            prop: 'id'
        },
        {
            label: '分组(岗位)',
            prop: 'groupName',
            minWidth: 120
        },
        {
            label: '关联指标编码',
            prop: 'kpiCode',
            minWidth: 160
        },
        {
            label: '关联指标名称',
            prop: 'kpiName',
            minWidth: 100
        },
        {
            label: '权重',
            prop: 'weight'
        },
        {
            label: '展示顺序',
            prop: 'sort'
        },
        {
            label: '状态',
            prop: 'groupKpiStatus',
            type: 'select',
            optionsKey: 'CRM_GOAL_STATUS'
        },
        {
            label: '创建人',
            prop: 'createUserName'
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 150
        },
        {
            label: '修改人',
            prop: 'updateUserName'
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 150
        }
    ],
    importConfig: {
        downBtn: true,
        downParams: {
            fileName: '分组关联指标导入模板.xlsx'
        },
        downloadApi: downloadGroupKpiReportTemplate,
        importApi: importGroupKpiReportList
    }
};
